import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEdiMoveNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEdiMoveNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEdiMoveNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of data',
            default: 'default'
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to move data to',
            default: 'default'
        }
    },
}

export const nodeDescription: string = "This node is used to ,.\n" +
    "This can be via logging, showing a custom error message to the user, or ending the workflow.";

